__turbopack_context__.v({
  "bars": "EnergyBar-module__ajhh-q__bars",
  "currentBar": "EnergyBar-module__ajhh-q__currentBar",
  "currentLabel": "EnergyBar-module__ajhh-q__currentLabel",
  "emptyBar": "EnergyBar-module__ajhh-q__emptyBar",
  "futureBar": "EnergyBar-module__ajhh-q__futureBar",
  "futureLabel": "EnergyBar-module__ajhh-q__futureLabel",
  "infoLink": "EnergyBar-module__ajhh-q__infoLink",
  "labels": "EnergyBar-module__ajhh-q__labels",
  "wrapper": "EnergyBar-module__ajhh-q__wrapper",
});
